import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { CheckboxInput } from "components/table/carousel/inputs"

const SalesInherit = (props: {rowData: [], field: string, namedItems: {}, defaults: {}, persist: Function}) => {
  const [data, setData] = useState<object|null>(_.get(props, "rowData.salesdetail"));

  const emptyRecord = {}

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field]['state'] !== 'inherit') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData:object;
    if (val){
      nextData = {
        state: 'inherit',
        sales: 'Inherit'
      }
    } else nextData = { state: 'basic' }
    setData(nextData);
    props.persist(nextData, 'salesdetail', props.rowData)
  }

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <CheckboxInput 
            className="automated" 
            data={data!} 
            field="sales"
            persist={updateData} 
          />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default SalesInherit
